export const findById = (list: any[] | undefined, id: number) => {
  return list?.find((item) => item.id === id)
}
